import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import NovaAPI from "../../../Axios/NovaAPI";
import navigations from "../../../routes/routeNames";
import { AuthContext } from "../../../globalContext/auth/authProvider";
import { setAuth } from "../../../globalContext/auth/authActions";
import { API_STATUS, Roles } from "../../../consts/constants";
import {
  GENERIC_GET_API_FAILED_ERROR_MESSAGE,
  INVALID_CREDENTIALS,
  NOT_AUTHORISED,
  loginErrorMessages,
} from "../../../consts/errorMessages";
// import {
//   EMAIL_OTP_VERIFY,
//   EMAIL_OTP_RESEND,
// } from "../../../api/apiEndpoints";

const useLoginUser = () => {
  const [, authDispatch] = useContext(AuthContext);
  const navigate = useNavigate();
  const [loginStatus, setLoginStatus] = useState(API_STATUS.IDLE);
  const [loginUserResult, setLoginUserResult] = useState([]);
  const [errorWhileLoggingIn, setErrorWhileLoggingIn] = useState("");
  // // OTP state (commented out — no OTP flow for now)
  // const [pendingVerificationEmail, setPendingVerificationEmail] = useState("");
  // const [otp, setOtp] = useState("");
  // const [otpError, setOtpError] = useState("");
  // const [otpSuccess, setOtpSuccess] = useState("");
  // const [isVerifying, setIsVerifying] = useState(false);
  // const [resendCooldown, setResendCooldown] = useState(0);

  // useEffect(() => {
  //   if (resendCooldown <= 0) return;
  //   const timer = setTimeout(() => setResendCooldown((c) => c - 1), 1000);
  //   return () => clearTimeout(timer);
  // }, [resendCooldown]);

  const handleUserLogin = async (payload) => {
    try {
      setLoginStatus(API_STATUS.LOADING);
      errorWhileLoggingIn && setErrorWhileLoggingIn("");
      const res = await NovaAPI.post(`api/public/auth/login`, payload);
      if (res.status === 200) {
        // // Dentist with unverified email — show OTP screen (commented out)
        // if (res.data?.needsVerification) {
        //   setPendingVerificationEmail(res.data.email);
        //   setLoginStatus(API_STATUS.IDLE);
        //   setResendCooldown(60);
        //   return;
        // }

        setLoginStatus(API_STATUS.SUCCESS);
        setLoginUserResult(res.data);
        const id = res.data.id;
        const authToken = res.headers?.authorization;
        const role = res.data?.role;
        authDispatch(setAuth({ authToken: authToken, id, role }));
        if (role === Roles.dentist) {
          navigate(navigations.HOME);
          return;
        }
        navigate(navigations.ACCOUNTS);
        return;
      }
      setLoginStatus(API_STATUS.ERROR);
      setErrorWhileLoggingIn(GENERIC_GET_API_FAILED_ERROR_MESSAGE);
    } catch (err) {
      setLoginStatus(API_STATUS.ERROR);
      if (err.response?.data?.message) {
        if (
          err.response?.data?.message === loginErrorMessages.WRONG_CREDENTIALS
        ) {
          setErrorWhileLoggingIn(INVALID_CREDENTIALS);
          return;
        }
        if (err.response?.data?.message === loginErrorMessages.NOT_AUTHORIZED) {
          setErrorWhileLoggingIn(NOT_AUTHORISED);
          return;
        }
        setErrorWhileLoggingIn(err.response?.data?.message);
        return;
      }
      setErrorWhileLoggingIn(GENERIC_GET_API_FAILED_ERROR_MESSAGE);
    }
  };

  // // OTP handlers (commented out — no OTP flow for now)
  // const handleVerifyLoginOtp = async () => {
  //   if (!otp.trim()) {
  //     setOtpError("Please enter the verification code");
  //     return;
  //   }
  //   setIsVerifying(true);
  //   setOtpError("");
  //   try {
  //     const res = await NovaAPI.post(EMAIL_OTP_VERIFY, {
  //       email: pendingVerificationEmail,
  //       otp: otp.trim(),
  //     });
  //     const authToken = res.headers?.authorization;
  //     const id = res.data?.data?.id;
  //     const role = res.data?.data?.role ?? Roles.dentist;
  //     authDispatch(setAuth({ authToken, id, role }));
  //     setOtpSuccess("Email verified! Redirecting...");
  //     setTimeout(() => navigate(navigations.HOME), 1500);
  //   } catch (err) {
  //     setOtpError(
  //       err?.response?.data?.message || "Verification failed. Please try again."
  //     );
  //   } finally {
  //     setIsVerifying(false);
  //   }
  // };

  // const handleResendLoginOtp = async () => {
  //   if (resendCooldown > 0) return;
  //   setOtpError("");
  //   setOtpSuccess("");
  //   try {
  //     await NovaAPI.post(EMAIL_OTP_RESEND, {
  //       email: pendingVerificationEmail,
  //     });
  //     setOtpSuccess("A new verification code has been sent to your email.");
  //     setResendCooldown(60);
  //   } catch (err) {
  //     setOtpError(
  //       err?.response?.data?.message || "Failed to resend code. Please try again."
  //     );
  //   }
  // };

  // const clearVerification = () => {
  //   setPendingVerificationEmail("");
  //   setOtp("");
  //   setOtpError("");
  //   setOtpSuccess("");
  //   setResendCooldown(0);
  // };

  const isLoggingIn = loginStatus === API_STATUS.LOADING;
  const isSuccessfullyLoggedIn = loginStatus === API_STATUS.SUCCESS;
  const errorLogginIn = loginStatus === API_STATUS.ERROR;

  useEffect(() => {
    return () => {
      setLoginStatus(API_STATUS.IDLE);
      setLoginUserResult([]);
      setErrorWhileLoggingIn("");
    };
  }, []);

  return {
    errorLogginIn,
    errorWhileLoggingIn,
    handleUserLogin,
    isLoggingIn,
    isSuccessfullyLoggedIn,
    loginStatus,
    loginUserResult,
    setErrorWhileLoggingIn,
    // pendingVerificationEmail,
    // otp,
    // setOtp,
    // otpError,
    // setOtpError,
    // otpSuccess,
    // setOtpSuccess,
    // isVerifying,
    // handleVerifyLoginOtp,
    // resendCooldown,
    // handleResendLoginOtp,
    // clearVerification,
  };
};

export default useLoginUser;
